<template>
	<div class="mapContain clearfix">
		<div class="contain">
			<div id="mapChart"></div>
			<weborder :province='this.province'></weborder>
		</div>
	</div>
</template>

<script>
import echarts from 'echarts'
import weborder from './weborder.vue'
require('echarts/map/js/china')
require('echarts/lib/chart/map')
export default {
	data () {
		return {
			mapChart: '',
			province: {
				id: 330000,
				name: '浙江'
			},
			CITY: {
			    '北京': [116.46, 39.92],
			    '天津': [117.2, 39.13],
			    '河北': [114.48, 38.03],
			    '山西': [112.53, 37.87],
			    '内蒙古': [111.65, 40.82],
			    '辽宁': [123.38, 41.8],
			    '吉林': [125.35, 43.88],
			    '黑龙江': [126.63, 45.75],
			    '上海': [121.48, 31.22],
			    '江苏': [118.78, 32.04],
			    '浙江': [120.19, 30.26],
			    '安徽': [117.27, 31.86],
			    '福建': [119.3, 26.08],
			    '江西': [115.89, 28.68],
			    '山东': [117, 36.65],
			    '河南': [113.65, 34.76],
			    '湖北': [114.31, 30.52],
			    '湖南': [113, 28.21],
			    '广东': [113.23, 23.16],
			    '广西': [108.33, 22.84],
			    '海南': [110.35, 20.02],
			    '重庆': [106.54, 29.59],
			    '四川': [104.06, 30.67],
			    '贵州': [106.71, 26.57],
			    '云南': [102.73, 25.04],
				'西藏': [91.15, 29.30],
			    '陕西': [108.95, 34.27],
			    '甘肃': [103.73, 36.03],
			    '青海': [101.74, 36.56],
			    '宁夏': [106.27, 38.47],
			    '新疆': [87.68, 43.77],
			    '台湾': [1, 1],
			    '香港': [1, 1],
			    '澳门': [1, 1]
			},
			CITYMAPPING: {
				'北京': 110000,
			    '天津': 120000,
			    '江西': 360000,
				'西藏': 540000,
			    '上海': 310000,
			    '福建': 350000,
			    '广西': 450000,
			    '广东': 440000,
			    '山西': 140000,
			    '云南': 530000,
			    '辽宁': 210000,
			    '海南': 460000,
			    '吉林': 220000,
			    '宁夏': 640000,
			    '青海': 630000,
			    '内蒙古': 150000,
			    '四川': 510000,
			    '陕西': 610000,
			    '重庆': 500000,
			    '江苏': 320000,
			    '贵州': 520000,
			    '新疆': 650000,
			    '浙江': 330000,
			    '山东': 370000,
			    '甘肃': 620000,
			    '河南': 410000,
			    '黑龙江': 230000,
			    '河北': 130000,
			    '湖南': 430000,
			    '安徽': 340000,
			    '湖北': 420000,
			    '台湾': 100000,
			    '香港': 110000,
			    '澳门': 110000
			},
			data: [
		    ]
		}
	},
	components: {
		weborder
	},
	mounted () {
		this.mapChart = echarts.init(document.getElementById('mapChart'))
		this.mapChart.on('mouseover', (params) => {
			if (params.data) {
				this.selectProvinceId(params.name)
			}
		})
		this.getMapData()
	},
	methods: {
		convertData (cityName) {
			let res = []
			if (typeof (cityName) === 'string') {
				let geoCoord
				this.data.forEach(function (item, index) {
					if (item.name === cityName) {
						geoCoord = item.value
					}
				})
				res.push({name: cityName, value: this.CITY[cityName].concat(geoCoord)})
			} else {
				for (let i = 0; i < cityName.length; i++) {
					let geoCoord = this.CITY[cityName[i].name]
					if (geoCoord) {
						res.push({
							name: cityName[i].name,
							value: geoCoord.concat(cityName[i].value)
						})
					}
				}
			}
			return res
		},
		selectProvinceId (proname) {
			this.mapChart.setOption({
				series: [
					{
					},
					{
						data: this.convertData(proname)
					}
				]
			})
			this.$set(this, 'province', {name: proname, id: this.CITYMAPPING[proname]})
		},
		getMapData () {
			this.$http.get(`${this.baseUrl}getprovince?type=1`)
			.then((res) => {
				console.log(res)
				this.$set(this, 'data', JSON.parse(res.data).result)
				this.setOptions(JSON.parse(res.data).result)
			})
		},
		setOptions (myData) {
			let newData = []
			myData.forEach(function (item, index) {
				newData.push({name: item.name, value: item.value, id: item.id})
			})
			this.mapChart.setOption({
			    title: {
			        text: '权威地方官媒TOP5',
			        subtext: '   联盟权威地方官媒, 构建地方媒介网络',
			        left: '500px',
			        top: '50px',
			        itemGap: 20,
			        textStyle: {
			        	fontSize: 26,
			        	fontWeight: 'normal',
			            color: '#333'
			        }
			    },
			    tooltip: {
			        formatter: function (params) {
			            return params.name
			        }
			    },
			    visualMap: {
			        min: 0,
			        max: newData[0].value,
			        show: false,
			        calculable: false,
			        inRange: {
			            color: ['#5190ef', '#297efe', '#076aff']
			        }
			    },
			    geo: {
			        map: 'china',
			        label: {
			        	normal: {
	                    	show: false
			            },
			            emphasis: {
			                show: false
			            }
			        },
			        roam: false,
			        itemStyle: {
			            normal: {
			                areaColor: '#0e2338',
			                borderColor: '#2d4a69'
			            },
			            emphasis: {
			                areaColor: '#f57f17'
			            }
			        }
			    },
			    series: [
			        {
			            type: 'scatter',
			            coordinateSystem: 'geo',
			            roam: false,
			            hoverAnimation: true,
			            data: this.convertData(newData),
			            symbolSize: function (val) {
			            	if (val[2] === '0') {
			            		return 0
			            	} else {
			            		return (1 + (val[2] / newData[0].value)) * 15
			            	}
			            },
			            itemStyle: {
			                normal: {
			                    color: function (val) {
			                    	return '#f4e925'
			                    }
			                }
			            }
			        },
			        {
			            type: 'effectScatter',
			            coordinateSystem: 'geo',
			            data: this.convertData('浙江'),
			            roam: false,
			            showEffectOn: 'render',
			            rippleEffect: {
			                brushType: 'stroke'
			            },
			            symbolSize: function (val) {
			            	if (val[2] === '0') {
			            		return 0
			            	} else {
			            		return (1 + (val[2] / newData[0].value)) * 15
			            	}
			            },
			            hoverAnimation: true,
			            label: {
			                normal: {
			                    formatter: '{b}',
			                    position: 'right',
			                    show: true
			                }
			            },
			            itemStyle: {
			                normal: {
			                    color: '#f4e925',
			                    shadowBlur: 10,
			                    shadowColor: '#333'
			                }
			            },
			            zlevel: 1
			        }
			    ]
			})
		}
	}
}
</script>

<style lang='less'>
.mapContain{
	width: 100%;
	#mapChart{
		float: left;
		width: 800px;
		height: 800px;
	}
}
</style>



// WEBPACK FOOTER //
// mapchart.vue?6a15ca53